import {Table, TablePaginationConfig} from 'antd';
import {useMemo} from 'react';

import {header_height} from '../../../../css/var-export.scss';
import {PageCard} from '../../../../layout/page-card/page-card';
import {useSystem} from '../../../../provider/system/system-hook';
import {useUser} from '../../../../provider/user/user-hook';
import {LocationsAnalyticsTableDataType} from '../../../../service/online-presence/online-presence-type';
import {TableSorterHookReturnType} from '../../../../util/antd/table/table-sorter-hook';
import {PaginationHookType} from '../../../../util/pagination-hook/pagination-hook-type';
import {ProvidersEnum} from '../../../../util/type';

import {getAvailableColumns, getLocationsTableColumns} from './locations-table-helper';
import {LocationsTableSorterKeysType} from './locations-table-sorter';

type PropsType = {
    data?: Array<LocationsAnalyticsTableDataType>;
    pagination: PaginationHookType | false;
    availableCatalogs: Set<ProvidersEnum>;
    loading: boolean;
} & Pick<TableSorterHookReturnType<LocationsTableSorterKeysType>, 'getSortOrder' | 'setSorterOrder'>;

export function LocationsTable(props: PropsType): JSX.Element {
    const {data, pagination, availableCatalogs, getSortOrder, setSorterOrder, loading} = props;
    const {user} = useUser();

    const systemContext = useSystem();
    const {screen} = systemContext;
    const {width} = screen;

    const availableColumns = getAvailableColumns(
        getLocationsTableColumns({
            screenWidth: width,
            getSortOrder,
        }),
        availableCatalogs,
        user?.regionAvailableCatalogs
    );

    const paginationOptions: TablePaginationConfig | false = useMemo(() => {
        if (!pagination) {
            return false;
        }

        return {
            ...pagination,
            total: pagination.total,
            pageSize: pagination.pageSize,
            current: pagination.page,
            size: 'default',
            showSizeChanger: true,
            onChange: pagination.onChange,
        };
    }, [pagination]);

    return (
        <PageCard>
            <Table
                bordered
                columns={availableColumns}
                dataSource={data || []}
                loading={loading}
                onChange={(_newPagination: TablePaginationConfig, _filters, sorter) => {
                    setSorterOrder(sorter);
                }}
                pagination={paginationOptions}
                rowKey="companyId"
                scroll={{x: '100%'}}
                sticky={{
                    offsetHeader: Number.parseFloat(header_height),
                }}
                tableLayout="fixed"
            />
        </PageCard>
    );
}
